export const ContractTypesEnum = Object.freeze({
    PURCHASE_CONTRACT: "Purchase Contract",
    SALES_CONTRACT: "Sales Contract",
});